import React, {memo} from 'react';
import {IDialogType} from 'common/names';
import {Feature} from 'types/DiplomatFeature';
import {default as MuiMenuItem} from '@mui/material/MenuItem';
import {useSelector} from 'react-redux';
import {licenseSelectors} from 'redux/license';
import {useTreeViewContext} from './hooks/useTreeViewContext';
import {useOpenSubDialog} from 'features/layout/redux/hooks/useOpenSubDialog';

interface CoreProps {
   disabled?: boolean;
   features?: Feature[];
}

interface MenuItemTypeProps extends CoreProps {
   type?: IDialogType;
}

interface MenuItemRegularProps extends CoreProps {
   name?: string;
   onClick?: () => void;
}

type MenuItemProps = MenuItemTypeProps | MenuItemRegularProps;

const MenuItem = memo((props: MenuItemProps) => {
   const {type, features, disabled} = props as MenuItemTypeProps;
   const isFeatureSupported = useSelector(licenseSelectors.isFeatureSupported);
   const isSupported = features ? features.some((feature) => isFeatureSupported(feature)) : true;
   const {data, handleClose} = useTreeViewContext();

   const openSubDialog = useOpenSubDialog(type?.id || '', data);

   if (!isSupported) {
      return null;
   }

   const {name = type?.menuName, onClick = openSubDialog} = props as MenuItemRegularProps;
   return (
      <MuiMenuItem
         disabled={disabled}
         onClick={(ev) => {
            ev.preventDefault();
            ev.stopPropagation();
            handleClose(ev);
            onClick && onClick();
         }}
      >
         {name}
      </MuiMenuItem>
   );
});

export default MenuItem;
